import {
  MOBILE_VIEW_THRESHOLD_PX,
  ROUTE_CREATE_ACCOUNT,
  ROUTE_LOGIN,
  ROUTE_TERMS,
  REFERRAL_CODE_QUERY_PARAM_KEY,
} from '@1bill-app/constants';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { Platform } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { setReferralCodeForLocalStorage } from '@1bill-app/helpers/storage.helper';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.page.html',
  styleUrls: ['./landing-page.page.scss'],
})
export class LandingPagePage implements OnInit {
  terms = ROUTE_TERMS;
  signUp = ROUTE_CREATE_ACCOUNT;
  signIn = ROUTE_LOGIN;

  @ViewChild('slides', { static: true }) slides: IonSlides;

  constructor(
    private platform: Platform,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    // HIDEREFERRALCODES
    // const referralCode = this.route.snapshot.queryParamMap.get(REFERRAL_CODE_QUERY_PARAM_KEY);
    // if (referralCode) {
    //   setReferralCodeForLocalStorage(referralCode);
    //   // Other logic on referral code link e.g. route user directly to sign-up?
    // }
  }

  index: number = 0;
  mobile: boolean = true;

  async onSlideChange() {
    await this.slides.getActiveIndex().then((i) => {
      this.index = i;
    });

    return this.index;
  }

  get isDesktopView() {
    return this.platform.width() <= MOBILE_VIEW_THRESHOLD_PX;
  }

  onClose() {
    this.router.navigateByUrl('/dashboard');
  }

  ngOnInit() {}
}
